import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RatTestCodeMirror } from './RatTestCodeMirror';
import { testSelectors, updateTest } from '../../../../store/test';

const FactsInput: React.FC<{ isReadOnly?: boolean; onChange?: () => void }> = ({ isReadOnly, onChange }) => {
  const dispatch = useDispatch();
  const wordWrap = useSelector(testSelectors.wordWrap);
  const selectedTest = useSelector(testSelectors.selectedTest);
  const fact = selectedTest?.fact || '';
  const [value, setValue] = useState(fact);

  useEffect(() => {
    setValue(fact);
  }, [fact]);

  const dispatchChange = (value: string) => selectedTest && dispatch(updateTest({ ...selectedTest, fact: value }));

  const handleChange: any = (value: any) => {
    setValue(value);
    dispatchChange(value);
    onChange && onChange();
  };

  return (
    <RatTestCodeMirror
      value={value}
      onChange={handleChange}
      options={{
        placeholder: 'type facts',
      }}
      readOnly={isReadOnly}
      lineWrapping={wordWrap}
    />
  );
};

export { FactsInput };
